import {appUrl} from '@frontend/AppUrl'
import {ErrorBoundary} from '@frontend/components/ErrorBoundary'
import {CabinetRoutesContainer} from '@frontend/modules/private/shared/CabinetRoutesContainer'
import {type ComponentClass} from 'react'
import {
    Navigate,
    Outlet,
    Route,
} from 'react-router-dom'
import {ProtectClientSurveyInnerRoute} from '../modules/private/client_survey/components/ProtectClientSurveyInnerRoute'
import {AppPages} from './AppPages'

// Обертка на случай, если на странице произойдет ошибка при рендеринге.
const ErrorBoundaryComponent: ComponentClass = ErrorBoundary as unknown as ComponentClass

// Список путей ЛК пользователя приложения.
export function CabinetRoutes() {
    return (
        <Route
            Component={CabinetRoutesContainer}
            ErrorBoundary={ErrorBoundaryComponent}
        >
            <Route
                path={appUrl().cabinet.root}
                element={
                    <Navigate
                        to={appUrl().cabinet.default}
                        replace
                    />
                }
                ErrorBoundary={ErrorBoundaryComponent}
            />

            {/* Объявления. */}

            <Route
                path={appUrl().cabinet.ads.index}
                Component={AppPages.MyAdsPage}
                ErrorBoundary={ErrorBoundaryComponent}
            />

            <Route
                path={appUrl().cabinet.ads.create}
                Component={AppPages.AdFormPage}
                ErrorBoundary={ErrorBoundaryComponent}
            />

            <Route
                path={appUrl().cabinet.ads.edit}
                Component={AppPages.AdFormPage}
                ErrorBoundary={ErrorBoundaryComponent}
            />

            <Route
                path={appUrl().cabinet.ads.import}
                Component={AppPages.AdsImportPage}
                ErrorBoundary={ErrorBoundaryComponent}
            />

            {/* Исполнители услуг. */}

            <Route
                path={appUrl().cabinet.executors.index}
                Component={AppPages.MyExecutorsPage}
                ErrorBoundary={ErrorBoundaryComponent}
            />

            <Route
                path={appUrl().cabinet.executors.create}
                Component={AppPages.ExecutorFormPage}
                ErrorBoundary={ErrorBoundaryComponent}
            />

            <Route
                path={appUrl().cabinet.executors.edit}
                Component={AppPages.ExecutorFormPage}
                ErrorBoundary={ErrorBoundaryComponent}
            />

            {/* Авансы. */}

            <Route
                path={appUrl().cabinet.advancePayments.contractVerification}
                Component={AppPages.ClientContractVerificationPage}
                ErrorBoundary={ErrorBoundaryComponent}
            />

            <Route
                path={appUrl().cabinet.advancePayments.contractRework}
                Component={AppPages.ClientContractReworkPage}
                ErrorBoundary={ErrorBoundaryComponent}
            />

            <Route
                path={appUrl().cabinet.advancePayments.contractBankAccount}
                Component={AppPages.ClientContractBankAccountPage}
                ErrorBoundary={ErrorBoundaryComponent}
            />

            <Route
                path={appUrl().cabinet.advancePayments.surveyForm}
                Component={AppPages.ClientSurveyFormPage}
                ErrorBoundary={ErrorBoundaryComponent}
            />

            <Route
                element={
                    <ProtectClientSurveyInnerRoute
                        clientSurveyPageUrl={appUrl().cabinet.advancePayments.surveyForm}
                    >
                        <Outlet />
                    </ProtectClientSurveyInnerRoute>
                }
                ErrorBoundary={ErrorBoundaryComponent}
            >
                <Route
                    path={appUrl().cabinet.advancePayments.selectAdForAdvance}
                    Component={AppPages.ClientSurveySelectAdForAdvancePage}
                    ErrorBoundary={ErrorBoundaryComponent}
                />

                <Route
                    path={appUrl().cabinet.advancePayments.requestAdvanceForAd}
                    Component={AppPages.ClientSurveyRequestAdvanceForAdPage}
                    ErrorBoundary={ErrorBoundaryComponent}
                />
            </Route>

            <Route
                path={appUrl().cabinet.advancePayments.contract}
                Component={AppPages.ClientContractPage}
                ErrorBoundary={ErrorBoundaryComponent}
            />

            <Route
                path={appUrl().cabinet.transactions.index}
                Component={AppPages.TransactionsPage}
                ErrorBoundary={ErrorBoundaryComponent}
            />

            <Route
                path={appUrl().cabinet.advancePayments.priceList}
                Component={AppPages.PaidServicesPriceListPage}
                ErrorBoundary={ErrorBoundaryComponent}
            />

            {/* Заказы услуг */}

            <Route
                path={appUrl().cabinet.transactions.orderDetails}
                Component={AppPages.OrderDetailsPage}
                ErrorBoundary={ErrorBoundaryComponent}
            />

            {/* Служба поддержки. */}

            <Route
                path={appUrl().cabinet.supportTickets.index}
                Component={AppPages.SupportTicketsPage}
                ErrorBoundary={ErrorBoundaryComponent}
            />

            <Route
                path={appUrl().cabinet.supportTickets.details}
                Component={AppPages.SupportTicketDetailsPage}
                ErrorBoundary={ErrorBoundaryComponent}
            />

            {/* Разное. */}

            <Route
                path={appUrl().cabinet.settings.index}
                Component={AppPages.SettingsPage}
                ErrorBoundary={ErrorBoundaryComponent}
            />

            <Route
                path={appUrl().cabinet.subscriptions}
                Component={AppPages.SubscriptionsPage}
                ErrorBoundary={ErrorBoundaryComponent}
            />

            <Route
                path={appUrl().cabinet.notifications.index}
                Component={AppPages.NotificationsPage}
                ErrorBoundary={ErrorBoundaryComponent}
            />

            <Route
                path={appUrl().cabinet.chats.index}
                Component={AppPages.ChatsPage}
                ErrorBoundary={ErrorBoundaryComponent}
            />

            <Route
                path={appUrl().cabinet.reviews}
                Component={AppPages.MyReviewsPage}
                ErrorBoundary={ErrorBoundaryComponent}
            />

            <Route
                path={appUrl().cabinet.favorites}
                Component={AppPages.FavoritesPage}
                ErrorBoundary={ErrorBoundaryComponent}
            />

        </Route>
    )
}
